export enum ContentType {
  CDP = "CDP",
  POPULUS = "POPULUS",
}
// eslint-disable-next-line react-refresh/only-export-components
export enum InterestLevel {
  DECLINED = "DECLINED",
  INTERESTED = "INTERESTED",
  NEED_TIME = "NEED_TIME",
}

// eslint-disable-next-line react-refresh/only-export-components
export enum InterestReason {
  NONE = "NONE",
  OTHER = "OTHER",
  INSURANCE = "INSURANCE",
  NEED_MORE_TIME = "NEED_MORE_TIME",
  TRANSPORTATION = "TRANSPORTATION",
  TIME_CONSTRAINT = "TIME_CONSTRAINT",
  DOES_NOT_WANT_TO_KNOW = "DOES_NOT_WANT_TO_KNOW",
  ALREADY_BEING_FOLLOWED = "ALREADY_BEING_FOLLOWED",
  PREVIOUS_FAMILY_TESTING = "PREVIOUS_FAMILY_TESTING",
  PREVIOUS_PERSONAL_TESTING = "PREVIOUS_PERSONAL_TESTING",
}

export type PopulusAttributes = {
  zone: string;
  debug: string;
  network: string;
  partner: string;
  keywords: string;
  "visit-id": string;
  "age-range": number;
  "visit-stage": "during";
  "partner-subacct": string | null;
};

export type CDPCampaignImage = {
  url: string;
  height: number;
  width: number;
};

export type CDPCampaign = {
  id: string;
  name: string;
  start_date: string;
  end_date: string;
  keywords: string[];
  images: Array<CDPCampaignImage>;
};

export type Patient = {
  address1: string | null;
  address2: string | null;
  city: string | null;
  date_of_birth: string | null;
  first_name: string | null;
  last_name: string | null;
  phone_number: string | null;
  state: string | null;
  zip_code: string | null;
  preferred_appointment_time: PreferredAppointmentTime;
  screening_appointments_interest: PatientAppointmentsInterest;
};

export type AdvertContextType = {
  contentType: ContentType | null;
  cdpCampaign: CDPCampaign | null;
  populusAttributes: PopulusAttributes | null;
};

export type PreferredAppointmentTime = {
  id: number;
  availability: {
    anytime: boolean;
    monday?: Array<'AM' | 'PM'>;
    tuesday?: Array<'AM' | 'PM'>;
    wednesday?: Array<'AM' | 'PM'>;
    thursday?: Array<'AM' | 'PM'>;
    friday?: Array<'AM' | 'PM'>;
  };
  startTime: number | null;
  stopTime: number | null;
  createdAt: string;
  updatedAt: string;
}

type InterestData = {
  level: InterestLevel;
  reason?: InterestReason;
};

export type PatientAppointmentsInterest = {
  breast: InterestData | null;
  prostate: InterestData | null;
  cervical: InterestData | null;
  colon: InterestData | null;
  lung: InterestData | null;
  mri: InterestData | null;
  counseling: InterestData | null;
  testing: InterestData | null;
};
